export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00227.1a02ab2b.png";